import { TableParams } from '../types';

export const quarantineTypes = {
  GET_QUARANTINES: 'GET_QUARANTINES',
  GET_USER_HEALTH_QUARANTINE_BY_ID: 'GET_USER_HEALTH_QUARANTINE_BY_ID',
  GET_USER_LOCATION_QUARANTINE_BY_ID: 'GET_USER_LOCATION_QUARANTINE_BY_ID',
  GET_USER_CONTACT_QUARANTINE_BY_ID: 'GET_USER_CONTACT_QUARANTINE_BY_ID',
};

export type IQuarantineState = Readonly<{
  quarantines: Array<any>;
}>;

export type GetQuarantineDetailParam = { id: string };

export type GetQuarantinesParams = TableParams;
